import { render } from "./AnnotateButtons.vue?vue&type=template&id=411b4374&scoped=true"
import script from "./AnnotateButtons.vue?vue&type=script&lang=js"
export * from "./AnnotateButtons.vue?vue&type=script&lang=js"

import "./AnnotateButtons.vue?vue&type=style&index=0&id=411b4374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411b4374"]])

export default __exports__